module.exports = __webpack_public_path__ + "img/business.249343b9.svg";